import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useInfiniteQuery } from '@tanstack/react-query';
import getFetchFullListOptions from './get-options';
import selectListItems from './select';
var useFetchListItems = function useFetchListItems(_ref) {
  var id = _ref.id,
    select = _ref.select;
  return useInfiniteQuery(_objectSpread({
    select: select ? function (data) {
      return select(selectListItems(data));
    } : selectListItems,
    enabled: Boolean(id)
  }, getFetchFullListOptions({
    id: id
  })));
};
export default useFetchListItems;